<form [formGroup]="formGroup" *ngIf="!isLoading">
    <div>
        <!-- Title -->
        <label hlmLabel qa="select-employee-title" class="text-lg font-semibold text-gray-800 mb-4">Select Your Employee</label>

        <!-- No employee available -->
        <p
            qa="multi-service-no-employees"
            *ngIf="isBookMultiServiceEnabled && noEmployeeAvailable"
            class="text-sm text-red-600 font-medium"
        >
            No employee available. Please go back to the service page to adjust.
        </p>

        <!-- Employee Radio Group -->
        <hlm-radio-group formControlName="employee" class="flex flex-col gap-4">
            <div
                *ngFor="let emp of filteredEmployeeList"
                class="flex items-center justify-between hover:bg-gray-50 cursor-pointer transition-colors rounded-md"
            >
                <!-- Left side: Radio + Name + Duration -->
                <div class="flex items-center gap-2">
                    <hlm-radio [value]="emp.id" [id]="emp.id">
                        <hlm-radio-indicator indicator class="w-4 h-4 border-2 border-gray-400 rounded-full"></hlm-radio-indicator>
                    </hlm-radio>
                    <div class="flex flex-col">
                        <label hlmLabel class="medium" for="{{ emp.id }}" class="cursor-pointer font-bold">
                            {{ emp.id === '0' ? 'First Available Employee' : emp.name }}
                        </label>
                        <span *ngIf="isServicePriceAndDurationFeatureActive" class="text-sm text-text-secondary">
                            <ng-container *ngIf="shouldShowUpToForEmployee(emp)">up to </ng-container
                            >{{ getEmployeeDuration(emp) | duration }}
                        </span>
                    </div>
                </div>

                <!-- Right side: Price -->
                <div *ngIf="shouldShowServicePrice" class="text-right">
                    <span qa="service-price" class="medium">
                        <ng-template [ngIf]="emp.id === '0'" [ngIfElse]="employeePrice">
                            <ng-template [ngIf]="minEmployeePrice === maxEmployeePrice" [ngIfElse]="priceRange">
                                {{ minEmployeePrice | dsbCurrency: currencyCode : 'symbol' : '1.0-2' }}
                            </ng-template>
                            <ng-template #priceRange>
                                {{ minEmployeePrice | dsbCurrency: currencyCode : 'symbol' : '1.0-2' }}
                                -
                                {{ maxEmployeePrice | dsbCurrency: currencyCode : 'symbol' : '1.0-2' }}
                            </ng-template>
                        </ng-template>
                        <ng-template #employeePrice>
                            {{ getEmployeePrice(emp) | dsbCurrency: currencyCode : 'symbol' : '1.0-2' }}
                        </ng-template>
                    </span>
                </div>
            </div>
        </hlm-radio-group>
    </div>
</form>

<!-- loading -->
<div *ngIf="isLoading" class="w-full pt-3xl" skeletonScreen [showSkeleton]="true">
    <div class="h-xl w-[80%] mb-xl" skeletonData></div>
    <div class="h-xl mb-xl" skeletonData></div>
    <div class="h-xl mb-xl" skeletonData></div>
    <div class="h-xl mb-xl" skeletonData></div>
</div>
